import HomeBanner from "../../components/sections/front/HomeBanner";
import JobSection from "../../components/sections/front/JobSection";
import Post from "./Post";

const Home = () => {
  return (
    <>
      {/* <HomeBanner/> */}
      <JobSection />
      {/* <Post /> */}
    </>
  );
};

export default Home;
